<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  class="fill-transparent stroke-cyan-500 stroke-2"
>
  <path d="M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38" />
</svg>
